import { AfterContentChecked, AfterViewInit, Directive, ElementRef, EventEmitter, Input, isDevMode, OnDestroy, Output } from "@angular/core";
import { Subject } from "rxjs";
import { ResizeObserverHelper } from "ng/src/app/core/resize-observer-helper";
import { debounceTime, takeUntil } from "rxjs/operators";

@Directive({
	selector: '[onResize]'
})
export class ResizeObserverDirective implements AfterViewInit, AfterContentChecked, OnDestroy {
	@Input()
	debounceMS = 200;
	
	@Output()
	readonly onResize = new EventEmitter<ResizeObserverEntry>();
	
	private readonly destroy$ = new Subject();
	private needsCheck = isDevMode();
	
	constructor(
		private elRef: ElementRef
	) {}
	
	ngAfterViewInit(): void {
		const element = this.elRef.nativeElement;
		ResizeObserverHelper.observe(element).pipe(
			takeUntil(this.destroy$),
			debounceTime(this.debounceMS)
		)
			.subscribe(entry => this.onResize.emit(entry));
	}
	
	ngAfterContentChecked() {
		if (!this.needsCheck) return;
		
		// Warn if the element has no size properties when in DevMode as some Angular Elements will not correctly size their container
		// causing unexpected issues
		this.needsCheck = false;
		const hasEmptyRect = this.checkForEmptyRect();
		if (!document.body.contains(this.elRef.nativeElement) || hasEmptyRect) {
			throw new Error('The checked element has no size and may not respond to resize events properly.');
		}
	}
	
	ngOnDestroy(): void {
		this.destroy$.next();
	}
	
	private checkForEmptyRect() {
		return Object.values(this.elRef.nativeElement.getBoundingClientRect().toJSON()).every(entry => entry === 0);
	}
}